import { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import ARTICLES from "@/blogData";
import { BlogHeader } from "@/pages/BlogList";

export default function BlogPost() {
  const { slug } = useParams();
  const article = ARTICLES.find((a) => a.slug === slug);

  useEffect(() => {
    if (article) {
      document.title = `${article.title} | Nurrahma Logistics`;
      const meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute("content", article.excerpt);
    }
    window.scrollTo(0, 0);
  }, [article]);

  if (!article) {
    return (
      <div className="min-h-screen bg-[#F4F7FB] flex flex-col items-center justify-center px-4 text-center">
        <h1 className="text-2xl font-black text-blue-950 mb-3" data-testid="blog-not-found">Artikel tidak ditemukan</h1>
        <Link to="/blog" className="text-sm font-bold text-blue-900 hover:underline" data-testid="blog-back-list">← Kembali ke Blog</Link>
      </div>
    );
  }

  const others = ARTICLES.filter((a) => a.slug !== slug).slice(0, 3);

  return (
    <div className="font-sans antialiased bg-[#F4F7FB] text-slate-800 min-h-screen">
      <BlogHeader />
      <section className="bg-blue-950 text-white py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-xs font-bold uppercase tracking-widest text-amber-400">{article.category}</span>
          <h1 className="text-2xl sm:text-4xl font-black tracking-tight mt-2 leading-tight" data-testid="blog-post-title">{article.title}</h1>
        </div>
      </section>

      <article className="py-14 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          {article.image && (
            <img src={article.image} alt={article.imageAlt || article.title} className="w-full rounded-2xl border border-slate-200 shadow-sm mb-8" data-testid="blog-post-image" />
          )}
          {article.body.map((p, i) => (
            <p key={i} className="text-sm sm:text-base text-slate-700 leading-relaxed mb-5" data-testid={`blog-paragraph-${i}`}>{p}</p>
          ))}
          <div className="mt-10 p-6 rounded-2xl bg-amber-50 border border-amber-200 text-center">
            <h2 className="text-lg font-extrabold text-slate-900">Butuh Kirim Barang dari Makassar?</h2>
            <p className="text-xs text-slate-600 mt-1 mb-4">Hitung estimasi ongkir Anda atau langsung konsultasi dengan tim kami.</p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              {article.routeSlug && (
                <Link to={`/rute/${article.routeSlug}`} className="px-6 py-3 rounded-xl bg-amber-400 text-slate-950 font-bold text-sm hover:bg-amber-300 transition-colors" data-testid="blog-cta-route">
                  Lihat Rute Makassar–{article.routeSlug.replace("makassar-", "").split("-").map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(" ")}
                </Link>
              )}
              <Link to="/#kalkulator" className="px-6 py-3 rounded-xl bg-blue-900 text-amber-300 font-bold text-sm hover:bg-blue-950 transition-colors" data-testid="blog-cta-kalkulator">
                Cek Ongkir Sekarang
              </Link>
              <Link to="/#kontak" className="px-6 py-3 rounded-xl bg-white border border-slate-300 text-blue-900 font-bold text-sm hover:border-blue-400 transition-colors" data-testid="blog-cta-kontak">
                Formulir Permintaan Tarif
              </Link>
            </div>
            <a
              href={`https://wa.me/?text=${encodeURIComponent(`${article.title} — baca panduannya di ${window.location.origin}/blog/${article.slug}`)}`}
              target="_blank" rel="noopener noreferrer"
              className="mt-4 inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-emerald-600 text-white font-bold text-xs hover:bg-emerald-700 transition-colors"
              data-testid="blog-share-whatsapp">
              Bagikan Panduan Ini ke WhatsApp
            </a>
          </div>
        </div>
      </article>

      <section className="py-14 bg-[#EEF2F7] border-t border-slate-200">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-lg font-extrabold text-slate-900 tracking-tight mb-5">Panduan Lainnya</h2>
          <div className="space-y-3">
            {others.map((a) => (
              <Link key={a.slug} to={`/blog/${a.slug}`} className="block p-4 rounded-xl bg-white border border-slate-200 hover:border-blue-300 transition-colors text-sm font-bold text-blue-900" data-testid={`blog-related-${a.slug}`}>
                {a.title} →
              </Link>
            ))}
          </div>
          <p className="mt-8 text-center">
            <Link to="/blog" className="text-xs text-slate-500 hover:text-blue-900 transition-colors" data-testid="blog-back-list-bottom">← Semua Artikel</Link>
          </p>
        </div>
      </section>
    </div>
  );
}
